module.exports = __webpack_public_path__ + "static/media/icon_plus_white.cc6ef37f.svg";